/*
* Ginih Team
* Created by Marlon On February 17, 2020
*/

import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "../../../components/Grid/GridItem.jsx";
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import Button from "../../../components/CustomButtons/Button";
import Snackbar from "../../../components/Snackbar/Snackbar";
// @material-ui/core icons
import NotificationErrorIcon from "@material-ui/icons/Error";
import NotificationFailedIcon from "@material-ui/icons/Cancel";
import NotificationSuccessIcon from "@material-ui/icons/DoneAll";
import Select from "../../../components/CustomSelect/CustomSelect";
import makeAnimated from "react-select/animated";
// Models & service
// Styles
import formStyle from "../../../assets/jss/custom-components/formStyle";
import {NOTIFICATION_DURATION} from "../../../variables/coreConstants";
import {
    disableComponent,
    enableComponent,
    getData, isSuccessfulCreate,
    selectValidation,
} from "../../../utils/helpersFunctions";
import {assign} from "../../../services/statusService";
import {BASE_URL_CORE, CATEGORY_PRODUCT_ASSIGN} from "../../../variables/apiConstants";
import {primaryColor} from "../../../assets/jss/material-dashboard-react";
import {validateSession} from "../../../services/api";
import {withRouter} from "react-router-dom";
import {getProductsAvailable} from "../../../services/productService";
import {withTranslation} from "react-i18next";


const animatedComponents = makeAnimated();

class ProductCategoryAssignmentForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            product: '',
            productsOptions: [],
            loadingProducts: true,
            notificationMessage: '',
            notification: false,
            color: 'success',
            icon: NotificationSuccessIcon,
            disableField: false,
        };
        this.assignProduct = this.assignProduct.bind(this);
        this.cleanData = this.cleanData.bind(this);
    }

    componentDidMount() {
        this.request();
    }

    changeProductSelect = product => {
        this.setState({ product } );
    };

    cleanData() {
        this.setState({
            product: '',
        });
    }

    showNotification = (msj, color, icon, refresh) => {
        this.setState({
            notificationMessage: msj,
            color: color,
            icon: icon,
            notification: true,
        });

        window.setTimeout(
            function() {
                this.setState({ notification: false });

                if (refresh != null)
                    this.props.component.handleCloseForm("openAssignProduct", false, refresh);

            }.bind(this),
            NOTIFICATION_DURATION
        );
    };

    hideNotification = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ notification: false });
    };


    request() {
        let category = getData("category");

        let productValues;
        getProductsAvailable(category.id)
            .then((res) => {
                productValues = res.data.map( item => {
                    return { value: item.id , label: item.name };
                });
                this.setState({ productsOptions: productValues});
                this.setState({ loadingProducts: false} );
            })

            .catch((err) => {
                this.setState({ loadingProducts: false} );
                this.showNotification(err.response.data.message, "danger", NotificationFailedIcon, null);

                if (err.response)
                    validateSession(err.response, this.props.history);
            });
    }


    assignProduct() {
        const { t } = this.props;
        if (selectValidation(this.state.product)) {
            this.showNotification(t('SELECT_PRODUCT_REQUIRED'), "danger", NotificationErrorIcon, null);

        } else {
            let category = getData("category");
            let productsId= this.state.product.map( item => {
                return { id: item.value };
            });

            let dataParameters = {
                "categoryId": category.id,
                "products": JSON.stringify(productsId)
            };

            disableComponent(this, "disableField");
            assign(BASE_URL_CORE, CATEGORY_PRODUCT_ASSIGN, dataParameters)
                .then((response) => {
                    if (isSuccessfulCreate(response)) {
                        this.cleanData();
                        this.showNotification(response.data.message, "primary", NotificationSuccessIcon, true);

                    } else {
                        enableComponent(this, "disableField");
                        this.showNotification(response.data.message, "danger", NotificationErrorIcon, null);
                    }
                })
                .catch(error => {
                    enableComponent(this, "disableField");
                    this.showNotification(error.response.data.message, "danger", NotificationFailedIcon, null);

                    if (error.response)
                        validateSession(error.response, this.props.history);
                });
        }
    }


    render() {
        const { classes, component, t } = this.props;

        const AssignProdButton = () => (
            <Button
                color="primary"
                className={classes.buttonSpacing}
                onClick={() => this.assignProduct()}
                disabled={this.state.disableField}
            >
                {t('BTN_ASSIGN')}
            </Button>
        );

        return (
            <div className={classes.formContainer}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.selectControlMax}>
                            <InputLabel htmlFor="product" className={classes.selectTitle}>
                                {t('PRODUCTS_TEXT')}
                            </InputLabel>
                            <Select
                                value={this.state.product}
                                onChange={this.changeProductSelect}
                                components={animatedComponents}
                                options={this.state.productsOptions}
                                placeholder={t('SELECT_TEXT')}
                                isMulti={true}
                                isClearable={true}
                                maxMenuHeight={100}
                                closeMenuOnSelect={false}
                                theme={theme => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary: primaryColor[0],
                                    },
                                })}
                            />
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.rightPaper}>
                            <Button
                                color="white"
                                className={classes.buttonSpacing + " " + classes.cancelButton}
                                onClick={() => component.handleCloseForm("openAssignProduct", false, false)}
                            >
                                {t('BTN_CANCEL')}
                            </Button>
                            <AssignProdButton/>
                        </div>
                    </GridItem>
                    <Snackbar
                        place="tc"
                        color={this.state.color}
                        icon={this.state.icon}
                        message={this.state.notificationMessage}
                        open={this.state.notification}
                        closeNotification={this.hideNotification}
                        close
                    />
                </GridContainer>
            </div>
        );
    }
}

ProductCategoryAssignmentForm.propTypes = {
    classes: PropTypes.object,
    component: PropTypes.object.isRequired
};

export default withRouter(withStyles(formStyle)(withTranslation()(ProductCategoryAssignmentForm)));